<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">E2E 에이전트 목록</div>
        <!-- <w-group-save-button class="mr-r4" :disabled="selectedRowArray.length == 0" managetype-id="E2E"
        :rsc-event-rule-list="rscEventRuleList" :event-alarm-rule-list="eventAlarmRuleList" @group-save="groupSave"/> -->
        <el-button class="mr-r15" size="mini" :disabled="selectedRowArray.length === 0" @click="delAgentList">삭제</el-button>
      </div>
      <div>
        <el-button type="primary" size="mini" @click="onSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button size="mini" @click="onResetButton" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="e2eAgentTable"
      :column-default="columnDefault"
      :total="total" remote :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool"
      :show-custom-header="true" :editable="true"
      @condition-change="onChangeTable" @cell-dblclick="startEdit" @selection-change="changeHandleSelection"
      >
      <!-- editable slot -->
      <template slot-scope="scope" slot="input-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="number-slot">
        <w-number-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" @cell-edit-end="endEdit">
          <span slot="content">{{getValueAfterCheckEmpty(scope.row[scope.column.property])}}</span>
        </w-number-editor>
      </template>
      <template slot-scope="scope" slot="rsc-rule-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="rscEventRuleList"
          keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="event-rule-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="eventAlarmRuleList"
          keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit"/>
      </template>
    </el-table-wrapper>
    <!-- <w-e2e-agent-update-sliding-popup ref="e2eAgentUpdateSlidingPop" @load-data="loadData"></w-e2e-agent-update-sliding-popup> -->
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { isNil, isEmpty, cloneDeep } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import rulApi from '@/api/settings/common/rule';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';

import CellEditingMixin from '@/mixins/table/cell-editing';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WNumberEditor from '@/components/table/cell-editor/NumberEditor';
import WGroupSaveButton from '@/views/settings/basic/DeviceRegistration/components/GroupSaveButton';

// import WE2eAgentUpdateSlidingPopup from './popup/E2eAgentUpdateSlidingPopup';

export default {
  name: 'WE2eAgentList',
  mixins: [CellEditingMixin],
  components: {
    // WE2eAgentUpdateSlidingPopup,
    WSelectEditor,
    WInputEditor,
    WNumberEditor,
    WGroupSaveButton,
  },
  data() {
    return {
      isLoading: false,
      total: null,
      columnDefault,
      showSearchTool: false,
      selectedRowArray: [],
      changeFlag: false,
      rscEventRuleList: [], // 수집판단 정책 리스트
      eventAlarmRuleList: [], // 알람 정책 리스트
      tableData: [],
      tableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '에이전트명',
          editable: true,
          scopedSlot: 'input-slot',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: '에이전트 IP',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'connectedServiceCount',
          label: '연결 서비스 수',
          sortable: true,
          width: 150,
        },
        {
          prop: 'orderbyIndex',
          label: '정렬 순서',
          editable: true,
          scopedSlot: 'number-slot',
          sortable: true,
        },
        // {
        //   prop: 'rscEventRuleId',
        //   label: '수집/판단정책',
        //   scopedSlot: 'rsc-event-rule',
        //   remoteProp: 'rscrt.rule_tmpl_name',
        //   searchable: true,
        // },
        // {
        //   prop: 'eventAlarmRuleId',
        //   label: '이벤트/알림정책',
        //   scopedSlot: 'event-alarm-rule',
        //   remoteProp: 'eventrt.rule_tmpl_name',
        //   searchable: true,
        // },
        {
          prop: 'rscEventRuleId',
          label: '수집/판단정책',
          editable: true,
          scopedSlot: 'rsc-rule-slot',
          searchable: true,
          remoteProp: 'rscrt.rule_tmpl_name',
        },
        {
          prop: 'eventAlarmRuleId',
          label: '이벤트/판단정책',
          editable: true,
          scopedSlot: 'event-rule-slot',
          searchable: true,
          remoteProp: 'eventrt.rule_tmpl_name',
        },
        {
          prop: 'registDatetime',
          label: '장비등록일시',
          searchType: 'date',
          sortable: true,
          formatter: this.getDateFormatter,
          searchable: true,
        },
      ],
    };
  },
  created() {
    // 정책 api 호출
    rulApi.getRscEventRules().then((response) => {
      if (response.data.success) {
        this.rscEventRuleList = response.data.data;
      }
    });
    rulApi.getEventAlarmRulesByManagetypeId('E2E').then((response) => {
      if (response.data.success) {
        this.eventAlarmRuleList = response.data.data;
      }
    });
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getValueAfterCheckEmpty,
    loadData() {
      // agentList api
      const tableParams = this.$refs.e2eAgentTable.getParameter();
      const params = {
        ...tableParams,
      };
      this.isLoading = true;
      DeviceRegistrationE2eApi.getAgentList(params).then((response) => {
        const result = response.data.data;
        this.tableData = this.getEditableTableData(result, this.tableColumn);
        this.resetCellEditing();
        this.$emit('setAgentData', result);
        this.total = response.data.total;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    onSaveButton() {
      // 저장 이벤트
      const updatedData = this.getUpdatedDatas(this.tableData, true, ['objId', 'agentId']);
      const target = '에이전트';
      const action = msgUtil.action.SAVE;
      DeviceRegistrationE2eApi.updateAgentPolicy(updatedData).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    onResetButton() {
      this.loadData();
    },
    // 수정 popup 창
    // onDblClickRow(row) {
    //   this.$refs.e2eAgentUpdateSlidingPop.open(cloneDeep(row));
    // },
    delAgentList() {
      // agent 삭제
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const target = '에이전트';
        DeviceRegistrationE2eApi.deleteAgentList(this.selectedRowArray).then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 셀 편집 후처리
     * @author Ju
     */
    handlerEndEdit() {
      this.checkExistModifiedData(this.tableData);
    },
    groupSave(data) {
      if (!isEmpty(data)) {
        const checkedRows = cloneDeep(this.selectedRowArray);
        const updatedData = checkedRows.map((item) => Object.assign({}, item, data));
        const target = '에이전트';
        const action = msgUtil.action.SAVE;
        DeviceRegistrationE2eApi.updateAgentPolicy(updatedData).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/E2eAgentList.vue